module.exports = __webpack_public_path__ + "img/Platform_Gradients-14.6dae9c42.jpg";